import { Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { JobsFormComponent } from 'src/app/shared/components/jobs-form/jobs-form.component';
JobsFormComponent

@Component({
    selector: 'app-jobs',
    templateUrl: './jobs.component.html',
    styleUrls: ['./jobs.component.css'],
    standalone: false
})
export class JobsComponent implements OnInit {

  constructor(private titleService: Title) { }

  ngOnInit() {
    this.titleService.setTitle('Zeeker Solutions | Portal de Empleo');
  }

}
